import { jsxs as o, jsx as r } from "react/jsx-runtime";
import i from "../Typography/Typography.js";
import a from "../../assets/icons/play-icon.svg.js";
import e from "./TryDemo.module.scss.js";
var d = function d() {
  return /* @__PURE__ */o("div", {
    className: e.container,
    children: [/* @__PURE__ */o("div", {
      children: [/* @__PURE__ */r(i, {
        variant: "body2",
        color: "#000000",
        children: "Try a live demo"
      }), /* @__PURE__ */r(i, {
        variant: "body3",
        color: "#000000",
        children: "Explore Mashvisor"
      })]
    }), /* @__PURE__ */r("div", {
      className: e.iconWrapper,
      children: /* @__PURE__ */r(a, {})
    })]
  });
};
export { d as default };